(function (window, $, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.RemoteLog = window.JVZoo.RemoteLog || {};
    /**
     * Keep this value in sync with \JVZoo\Constant\HttpHeaderConstants::X_JVZ_PREVIOUS_APP_REQUEST_ID_HEADER
     * @type {string}
     */
    var JVZ_PREVIOUS_APP_REQUEST_ID_HEADER = 'X-Jvz-Previous-App-Request-Id';
    var REMOTE_LOG_URI = '/callbacks/remotelog/index'
    var DEBUG = 100;
    var INFO = 200;
    var NOTICE = 250;
    var WARNING = 300;
    var ERROR = 400;
    var CRITICAL = 500;
    var ALERT = 550;
    var EMERGENCY = 600;
    var _priorApplicationRequestId = null;

    window.JVZoo.RemoteLog.SetApplicationRequestId = function (responseUniqueId) {
        _priorApplicationRequestId = responseUniqueId;
    }
    window.JVZoo.RemoteLog.Debug = function (message, keyValuePairs) {
        _send(DEBUG, message, keyValuePairs);
    };
    window.JVZoo.RemoteLog.Info = function (message, keyValuePairs) {
        _send(INFO, message, keyValuePairs);
    };
    window.JVZoo.RemoteLog.Notice = function (message, keyValuePairs) {
        _send(NOTICE, message, keyValuePairs);
    };
    window.JVZoo.RemoteLog.Warning = function (message, keyValuePairs) {
        _send(WARNING, message, keyValuePairs);
    };
    window.JVZoo.RemoteLog.Error = function (message, keyValuePairs) {
        _send(ERROR, message, keyValuePairs);
    };
    window.JVZoo.RemoteLog.Critical = function (message, keyValuePairs) {
        _send(CRITICAL, message, keyValuePairs);
    };
    window.JVZoo.RemoteLog.Alert = function (message, keyValuePairs) {
        _send(ALERT, message, keyValuePairs);
    };
    window.JVZoo.RemoteLog.Emergency = function (message, keyValuePairs) {
        _send(EMERGENCY, message, keyValuePairs);
    };

    var _send = function (levelId, message, logContextObject) {

        var formData = new FormData();
        formData.append('log-message', message);
        formData.append('log-level-id', levelId);
        if (logContextObject && "object" === typeof(logContextObject)) {
            formData.append('log-context', JSON.stringify(logContextObject));
        }

        headers = {};
        headers[JVZ_PREVIOUS_APP_REQUEST_ID_HEADER] = _priorApplicationRequestId;

        return fetch(
            REMOTE_LOG_URI,
            {
                method: 'POST',
                headers: headers,
                mode: 'same-origin',
                cache: 'no-cache',
                credentials: 'same-origin',
                redirect: 'error',
                referrerPolicy: 'same-origin',
                body: formData,
            }
        ).catch(
            // ensure any errors are caught and logged
            function (any) {
                console.error("remote_log error: ", any);
            }
        );
    }
})(window, jQuery)